import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import { ArcAlert, ArcText } from '@src/core/ui';

import { useTerrainSeries } from '@src/features/order/pages/upsert-mission-page/hooks';

import { TerrainAlertProps } from './types';

// Match the step 4 (confirm order) message box sizing: tight padding + caption-sized text.
const alertSx = { py: 0.2, px: 1, '& .MuiAlert-icon': { marginLeft: '3px' } };

const TerrainAlert: React.FC<TerrainAlertProps> = () => {
  const { isLoading, hasCrashZoneCollision, terrainData } = useTerrainSeries();

  // The terrain mutation re-fires often during the single-page flow (auto-persist + re-plan),
  // which briefly flips `isLoading` true and clears `terrainData`. Hiding on every transient
  // reload made the box "disappear". Keep it visible once terrain has loaded at least once;
  const hasLoadedRef = React.useRef(false);
  if (terrainData.length > 0) hasLoadedRef.current = true;

  if (!hasLoadedRef.current && isLoading) return null;

  if (!hasCrashZoneCollision) {
    return (
      <ArcAlert severity='success' sx={alertSx}>
        <ArcText.caption color='success.main'>
          No terrain collision detected. Current altitudes are safe.
        </ArcText.caption>
      </ArcAlert>
    );
  }

  return (
    <ArcAlert severity='error' icon={<WarningAmberIcon />} sx={{ bgcolor: 'error.background', ...alertSx }}>
      <ArcText.caption color='error.main'>
        Terrain collision detected. Current altitudes are unsafe, adjust them before takeoff.
      </ArcText.caption>
    </ArcAlert>
  );
};

export default TerrainAlert;
